import type { EdgeTypes } from "@xyflow/react";

import TriggerEdge from "./TriggerEdge";

export { default as TriggerEdge } from "./TriggerEdge";
export type { TriggerEdgeData } from "./TriggerEdge";

export const playgroundEdgeTypes: EdgeTypes = {
  trigger: TriggerEdge,
};
